module.exports = __webpack_public_path__ + "img/a8ecd942586b64c3de43b8755627f27f.png";